/*
 * @Author: your name
 * @Date: 2021-11-05 11:20:06
 * @LastEditTime: 2021-12-17 11:00:33
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \yhb_invite-download\src\api\index.js
 */
import {
	req,
	reqloading,
	rysReqloading,
	rysRequestXcx,
	kxsRequestXcx
} from '@/utils/request'
import axios from 'axios'

// 上传图片
export function upload(data) {
	return req({ //需要loading加载
		url: '/file/upload',
		method: 'post',
		data: data
	})
}


// 需要loading
export function getuserInfos(obj) {
	return reqloading({ //需要loading加载
		url: '/List.php',
		method: 'get',
		params: obj,
	})
}

// 下载app
export function downloadApp(data) {
	return reqloading({ //需要loading加载
		url: `/web/sys-version/newest?equipment=${data}`,
		method: 'get'
	})
}

//  获取注册页面的 隐私政策  
export function getRegisteredAgreement(data) {
	return reqloading({ //需要loading加载
		url: '/app/homeArticle/list',
		method: 'post',
		data: data
	})
}

// 获取 卡盒授权协议
export function khAuthorizationAgreement() {
	return reqloading({ //需要loading加载
		url: `/app/CreditCard/getAgreement?typeId=1`,
		method: 'get'
	})
}

//  用户注册服务协议 
export function khRegistrationAgreement() {
	return reqloading({ //需要loading加载
		url: `/app/CreditCard/getAgreement?typeId=2`,
		method: 'get'
	})
}

//  聚收宝用户注册服务协议 
export function JSBkhRegistrationAgreement(type) {
	return reqloading({ //需要loading加载
		url: `/app/feedback/getAgreement?typeId=${type}`,
		method: 'get'
	})
}

//  聚收宝小账本获取用户信息绑定 
export function getMpOpenId(data) {
	return reqloading({ //需要loading加载
		url: `/jsb/xzb/getMpOpenId`,
		method: 'post',
		data: data
	})
}

// 注册易伙伴App  /auth/app/register
export function register(data) {
	return reqloading({ //需要loading加载
		// url: '/auth/app/register', // 旧
		url: '/system/user/registers', // 新(同App)
		method: 'post',
		data: data
	})
}

//  获取验证码
export function getCode(phone) {
	return reqloading({ //需要loading加载
		url: `/auth/app/code?phoneNumber=${phone}`,
		method: 'get'
	})
}

// 信用卡记录 提交
export function Submit(data) {
	return reqloading({ //需要loading加载
		url: '/credit/credith5/addApply',
		method: 'post',
		data: data
	})
}

// 获取信用卡连接
export function link(data) {
	return reqloading({ //需要loading加载
		url: '/credit/app/link?code=' + data.code,
		method: 'get'
	})
}
// 获取文章详情
export function articleDetails(data) {
	return reqloading({ //需要loading加载
		url: '/app/businessSchool/articleDetails?id=' + data,
		method: 'get'
	})
}

// 获取如意刷隐私政策
export function getAgreement(data) {
	return rysReqloading({ //需要loading加载
		url: `/app/feedback/getAgreement?typeId=${data}`,
		method: 'get'
	})
}
// 人脸认证识别成功
export function face(mId, code) {
	return rysReqloading({ //需要loading加载
		url: `/app/notify/kdb/face?mId=${mId}&code=${code}`,
		method: 'get'
	})
}

// 人脸认证识别成功
export function facexcx(mId, code) {
	return rysRequestXcx({ //小程序单独请求
		url: `/app/notify/kdb/face?mId=${mId}&code=${code}`,
		method: 'get'
	})
}

// 意愿核身识别成功
export function will(mId, code) {
	return rysReqloading({ //需要loading加载
		url: `/app/notify/kdb/willFace?mId=${mId}&code=${code}`,
		method: 'get'
	})
}
// export function will(mId, code) {
//     return ScRequest({ //需要loading加载
//         url: `/app/notify/kdb/willFace?mId=${mId}&code=${code}`,
//         method: 'get'
//     })
// }

// 意愿核身识别成功
export function willxcx(mId, code) {
	return rysRequestXcx({ //小程序单独请求
		url: `/app/notify/kdb/willFace?mId=${mId}&code=${code}`,
		method: 'get'
	})
}

// 乐刷意愿核身识别成功
export function getWillIdentifyResult(orderNo, code) {
	return rysReqloading({
		url: `/app/kdbMerchant/getWillIdentifyResult?serialNo=${orderNo}&code=${code}`,
		method: 'get'
	})
}
// 小程序意愿核身识别成功
export function getWillIdentifyResultxcx(orderNo, code) {
	return rysRequestXcx({ //小程序单独请求
		url: `/app/kdbMerchant/getWillIdentifyResult?serialNo=${orderNo}&code=${code}`,
		method: 'get'
	})
}
//开心刷
export function getkxsWillIdentifyResultxcx(orderNo, code) {
	return kxsRequestXcx({ //小程序单独请求
		url: `/kxs/bindingCard/getWillIdentifyResult?serialNo=${orderNo}&code=${code}`,
		method: 'get'
	})
}
// 获取信用卡连接
export function getChatInfo(data) {
	return reqloading({ //需要loading加载
		url: '/chat/fineTunes/get-chat-info',
		method: 'post',
		data: data
	})
}

// 通过城市adcode获取城市信息
export function getCity(adcode) {
	return axios.get(
		`https://restapi.amap.com/v3/config/district?key=5a1ae477a13cd3cf142bae6f83eaf576&keywords=${adcode}&subdistrict=2`,
	)
}

//  如意刷用户注册服务协议 
export function rysUserAgreement(type) {
	return reqloading({ //需要loading加载
		url: `/app/feedback/getAgreement?typeId=${type}`,
		method: 'get'
	})
}
// 通过资源id获取屏蔽省市
export function getShieldedArea(id) {
	return reqloading({ //需要loading加载
		url: `/credit/creditResourceBlockCity/queryBlockCityByResourceId?resourceId=${id}`,
		method: 'get'
	})
}
//  易伙伴人脸成功接口
export function setMerchProduct(data) {
	return rysReqloading({ //需要loading加载
		url: `/app/merchRegister/merchLiveOrder`,
		method: 'POST',
		data
	})
}
//  获取资源
export function getCreditTypeList(token) {
	return reqloading({ //需要loading加载
		url: `/credit/type/all`,
		headers: {
			Authorization: token
		},
		method: 'get'
	})
} 
// 信用卡列表
export function getCreditList(data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/page?typeId=${data}`,
		headers: {
			Authorization: token
		},
		method: 'get'
	})
}
// 参与活动资源列表
export function getParticipationCreditList(data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/activityPage`,
		headers: {
			Authorization: token
		},
		method: 'get',
		params: data
	})
}

// 活动入口
export function getActivityEntry(data,token) {
	return reqloading({ //需要loading加载
		url: '/credit/creditActivityInfo/queryActivityTitle',
		method: 'post',
		headers: {
			Authorization: token
		},
		data: data
	})
}
// 数据列表
export function getDataList(pageNum,pageSize,data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityInfo/queryDataApp?pageNum=${pageNum}&pageSize=${pageSize}`,
		method: 'post',
		headers: {
			Authorization: token
		},
		data: data
	})
}
// 资源详情
export function getCreditDetail(data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/query?creditId=${data}`,
		headers: {
			Authorization: token
		},
		method: 'get',
	})
}
// 抽奖次数
export function getPrizeLeftNum(data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityUser/prizeLeftNum`,
		method: 'get',
		params: data,
		headers: {
			Authorization: token
		},
	})
}
// 达标数据
export function queryCompleteCreditNum(data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/queryCompleteCreditNum?activityId=${data}`,
		method: 'get',
		headers: {
			Authorization: token
		},
	})
}
// 获取中奖列表
export function getListofWinners(data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityPrizeLog/prizeLogList`,
		method: 'post',
		data: data,
		headers: {
			Authorization: token
		},
	})
}
// 获取奖品信息
export function getPrizeInformation(data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityPrize/prizeList`,
		method: 'get',
		params: data,
		headers: {
			Authorization: token
		},
	})
}
// 抽奖
export function getDrawward(data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityInfo/prizeReward`,
		method: 'get',
		params: data,
		headers: {
			Authorization: token
		},
	})
}
// 订单状态下拉
export function getOrderStatus(token) {
	return reqloading({ //需要loading加载
		url: `/credit/appOrderStatusInfo`,
		method: 'get',
		headers: {
			Authorization: token
		},
	})
}
// 申卡订单
export function getOrderList(pageNum,pageSize,data,token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/orderList?pageNum=${pageNum}&pageSize=${pageSize}`,
		method: 'post',
		headers: {
			Authorization: token
		},
		data: data
	})
}
// 获取openid
export function getOpenidBycode(data) {
	return reqloading({ //需要loading加载
		url: `/credit/getOpenIdByCode?code=${data}`,
		method: 'get',
		
	})
}
// 信用卡容易申公众号注册新的用户
export function getrongYiShenRegister(data) {
	return reqloading({ //需要loading加载
		url: `/credit/rongYiShenRegister`,
		method: 'post',
		data: data
	})
}
